// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-title[data-v-6ff01ac0] {\n  padding-left: 35px;\n  margin: 20px 0;\n  font-size: 16px;\n  color: #464646;\n  font-weight: 600;\n}\n.tab-input[data-v-6ff01ac0] {\n  width: 350px;\n}\n[data-v-6ff01ac0] .el-form-item {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
